import type { ScreenFilters, ScreenListItem } from './ScreensStep.types';
import { buildScreenLocation } from '@/features/billboards/utils/billboardsListUtils';

type ListPayload = {
  data?:
    | ScreenListItem[]
    | {
        billboards?: ScreenListItem[];
        pagination?: { pages?: number; totalPages?: number };
      };
  pagination?: { pages?: number; totalPages?: number };
};

export function countActiveScreenFilters(
  filters: ScreenFilters,
  hasLocality: boolean,
  hasAreaQuery = false,
) {
  return (
    Number(filters.locationType.length > 0) +
    Number(filters.venueType.length > 0) +
    Number(filters.venueSubType.length > 0) +
    Number(Boolean(hasLocality)) +
    Number(Boolean(hasAreaQuery))
  );
}

function uniqueValues(values: string[]) {
  return [...new Set(values.filter(Boolean))];
}

export function pruneScreenFilters(
  filters: ScreenFilters,
  availableMidKeys: string[],
  availableSubKeys: string[],
): ScreenFilters {
  const midSet = new Set(availableMidKeys);
  const subSet = new Set(availableSubKeys);
  return {
    ...filters,
    venueType: filters.venueType.filter((item) => midSet.has(item)),
    venueSubType: filters.venueSubType.filter((item) => subSet.has(item)),
  };
}

export function nextScreenFilters(
  prev: ScreenFilters,
  key: keyof ScreenFilters,
  value: string[],
): ScreenFilters {
  return { ...prev, [key]: uniqueValues(value) };
}

export function parseScreenList(payload: ListPayload | undefined) {
  const data = payload?.data;
  if (!data) return [] as ScreenListItem[];
  if (Array.isArray(data)) return data;
  return data.billboards ?? [];
}

export function parseScreenTotalPages(payload: ListPayload | undefined) {
  const nested =
    payload?.data && !Array.isArray(payload.data)
      ? payload.data.pagination
      : undefined;

  return (
    Number(
      nested?.pages ??
        nested?.totalPages ??
        payload?.pagination?.pages ??
        payload?.pagination?.totalPages,
    ) || 1
  );
}

export function screenLocationLabel(screen: ScreenListItem) {
  return buildScreenLocation(screen) || '—';
}

export function screenId(screen: ScreenListItem) {
  return String(screen._id || screen.id || '');
}
